const eventer = require('./util/eventer');

const api = eventer({});
let user = {};

function userSignedIn(data) {
  return !!(data && data.id);
}

function signedIn() {
  return userSignedIn(user);
}

function onSignIn(ondone) {
  if (signedIn()) ondone(data());
  api.on('auth', () => ondone(data()));
}

function init({ syncApi }) {
  if (init.promise) return init.promise;
  return init.promise = syncApi.user.reader().then(set)
    .catch(() => {});
}

function data() {
  return Object.assign({}, user);
}

function set(_user, auth) {
  let old = user;
  user = _user;
  user.auth = user.auth || auth || 'login';
  if (!userSignedIn(old) && userSignedIn(user)) {
    api.trigger('auth', [user]);
  }
  api.trigger('change', [user]);
  return user;
}

function inProgram(name) {
  return user.programs && user.programs.indexOf(name) != -1;
}

api.init      = init;
api.set       = set;
api.onSignIn  = onSignIn;
api.inProgram = inProgram;

Object.defineProperty(api, 'id', { get() { return user.id; } });
Object.defineProperty(api, 'data', { get() { return data(); } });
Object.defineProperty(api, 'signedIn', { get() { return signedIn(); } });
Object.defineProperty(api, 'organization', { get() { return user.organization; } });
Object.defineProperty(api, 'licence', { get() { return user.licence; } });
Object.defineProperty(api, 'aiEnabled', { get() { return user.licence?.reader_ai_enabled } });

module.exports = api;
